import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs/index';
import { SystemSettingsState } from './system-settings.state';

const systemSettingsSelector = (state: SystemSettingsState) => (state as any).systemSettings as SystemSettingsState;

@Injectable({
    providedIn: 'root' // No need to provide in AppModule, and now tree shakable
})
export class SystemSettingsSelectors {
    constructor(private store: Store<any>) {
    }

    selectSystemSettings(): Observable<any> {
        return this.store.pipe(select(systemSettingsSelector));
    }
}
